import { Card } from "shared/components/Card";
import { Loader } from "shared/components/Loader";
import { Show } from "shared/components";
import { cx } from "shared/utils";
import { NoShowReasonBar, type NoShowReasonSegment } from "./NoShowReasonBar";

export const ShowingsCard = ({
  title,
  count,
  isLoading,
  onClick,
  breakdown
}: {
  title: string;
  count: number | undefined;
  isLoading: boolean;
  onClick: () => void;
  breakdown?: NoShowReasonSegment[];
}) => (
  <Card onClick={onClick} className="space-y-2 p-6">
    <p className="text-sm font-medium text-content-1000">{title}</p>
    {isLoading ? (
      <Loader size={24} />
    ) : (
      <div className={cx("flex items-center", breakdown && "gap-4")}>
        <p className="text-2xl font-bold text-content-1000">{count ?? "-"}</p>
        <Show if={!!breakdown}>
          <NoShowReasonBar segments={breakdown ?? []} />
        </Show>
      </div>
    )}
  </Card>
);
